// extracted by mini-css-extract-plugin
export default {"recycling_mask":"styles_recycling_mask__xaG1T","container":"styles_container__dE4vc","title":"styles_title__iyOH+","btns":"styles_btns__h8YtS","btn":"styles_btn__YJWrv"};